import Download from "./Download.jsx";
import Faq from "./Faq.jsx";
import Hero from "./Hero.jsx";
import HowItWork from "./HowItWork.jsx";
import PopularRoute from "./PopularRoute.jsx";
import Safety from "./Safety.jsx";
import SeatAllocation from "./SeatAllocation.jsx";
import Testimonials from "./Testimonials.jsx";
import TrustBar from "./TrustBar.jsx";
export default function Home() {
  return (
    <>
      <main id="top">
        <Hero />
        <TrustBar />
        <HowItWork />
        <SeatAllocation />
        <PopularRoute />
        <Safety />
        <Testimonials />
        <Download />
        <Faq />
      </main>
    </>
  );
}
